import { api } from "api";
import type { FileWithPath } from "react-dropzone";

export async function loadFiles(
  executionId: string,
  filenames?: string[],
): Promise<FileWithPath[]> {
  if (!filenames?.length) {
    return [];
  }
  const files = await Promise.all(
    filenames.map(async filename => {
      const url = api.artifactURL(executionId, filename);
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`failed to fetch ${url}: ${response.status}`);
      }
      const blob = await response.blob();
      return new File([blob], filename);
    }),
  );
  return files;
}
